<template>
  <div>
    <h1 class="page-header">Machine File {{ machineFile.static.machineSerialNumber }}</h1>
    <h3 class="page-header">Revision {{ machineFileRevision }}</h3>
    <div v-if="machineFile" class="row">
      <div class="col-md-6">
        <static-data :data="machineFile"></static-data>
        <weight-data :data="machineFile"></weight-data>
        <application-data :data="machineFile"></application-data>
        <media-data :data="machineFile"></media-data>
      </div>
      <div class="col-md-6">
        <suspension-data :data="machineFile"></suspension-data>
        <lubrication-data :data="machineFile"></lubrication-data>
        <motor-data :data="machineFile"></motor-data>
        <revision-data :data="machineFile"></revision-data>
      </div>
    </div>
    <div v-else class="text-center">
      <span v-if="errorText">{{ errorText }}</span>
      <b-spinner v-else label="Loading..." show variant="secondary"></b-spinner>
    </div>
  </div>
</template>

<script>
import staticData from '@/components/machine_file/StaticData.vue'
import weightData from '@/components/machine_file/WeightData.vue'
import applicationData from '@/components/machine_file/ApplicationData.vue'
import mediaData from '@/components/machine_file/MediaData.vue'
import suspensionData from '@/components/machine_file/SuspensionData.vue'
import lubricationData from '@/components/machine_file/LubricationData.vue'
import motorData from '@/components/machine_file/MotorData.vue'
import revisionData from '@/components/machine_file/RevisionData.vue'
import { machineFilesApi } from '@/backend'

export default {
  name: 'MachineDetailsPage',
  components: {
    staticData,
    weightData,
    applicationData,
    mediaData,
    suspensionData,
    lubricationData,
    motorData,
    revisionData
  },
  data () {
    return {
      machineFile: null,
      errorText: null,
      machineFileRevision: null
    }
  },
  mounted () {
    this.fetchMachineFileRevision()
  },
  computed: {
    machineId: function () {
      return this.$route.params.machineId
    },
    revision: function () {
      return this.$route.params.revision
    }
  },
  methods: {
    fetchMachineFileRevision () {
      machineFilesApi.getMachineFileRevision(this.machineId, this.revision, (error, data) => {
        if (error) {
          this.errorText = 'Failed fetching machine data'
          console.error('Failed fetching machine because: ' + error)
          return
        }
        this.machineFile = data.machine_file_data
        this.machineFileRevision = data.revision
        this.errorText = null
      })
    }
  }
}
</script>
